import { Card, CardContent, Chip, Typography } from "@mui/material";
import React from "react";
import { BrowserRouter, Link, Route } from "react-router-dom";
import "../index.css";
import Pokemon from "../pages/Pokemon";
import "../index.css";
function PokemonCard(props) {
  return (
    <div>
      <a href={`/pokemon/${props.name}`} className="pokemon">
        <div className="hover">
          <Card variant="outlined">
            <CardContent>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                }}
              >
                {/* <img
              style={{
                minWidth: "100px",
                maxWidth: "100px",
              }}
              src={`https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/${props.id}.png`}
              alt={props.name}
            /> */}
                <img
                  id="pokemonCard"
                  style={{
                    minWidth: "100px",
                    maxWidth: "120px",
                  }}
                  src={`https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/${props.id}.png`}
                />
              </div>
            </CardContent>
            <Typography variant="h4">{props.name}</Typography>
          </Card>
        </div>
      </a>
    </div>
  );
}

export default PokemonCard;
